import React from 'react'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import Reveal from 'components/Reveal'

function Cta() {
  return (
    <section className='section-h-half dorac-grid-bg py-20 md:py-32'>
      <div className='container mx-auto px-4'>
        <Reveal className='mx-auto max-w-3xl text-center'>
          <h2 className='section-title mb-6'>
            Pronto para transformar sua <span className='text-dorac-purple'>comunicação em resultado</span>?
          </h2>
          <p className='section-subtitle mx-auto mb-10'>
            Agende um diagnóstico estratégico gratuito e descubra o que precisa acontecer dentro das pessoas para que
            sua marca cresça por fora.
          </p>
          <div className='flex flex-col justify-center gap-4 sm:flex-row'>
            <Link to='/contato' className='btn-dorac gap-2 px-8 py-4 text-base'>
              Solicitar diagnóstico gratuito
              <ArrowRight className='h-4 w-4' />
            </Link>
            <a
              href='https://api.whatsapp.com/send?phone=554396659096&text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20um%20diagn%C3%B3stico%20estrat%C3%A9gico!'
              target='_blank'
              rel='noopener noreferrer'
              className='btn-dorac-outline px-8 py-4 text-base'
            >
              Falar pelo WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  )
}

export default Cta
